export default class FaqItems
{
  constructor(questions, answers) 
  {
    this.questions = questions; // {} instead of array to support stringify
    this.answers = answers; // {} instead of array to support stringify
  }    

  isValid()
  {
    var result = true;

    // Questions
    for (const [key, value] of Object.entries(this.questions)) {
      if(!value)
      {
        result = false;
        break;
      };
    }

    // Answers
    for (const [key, value] of Object.entries(this.answers)) {
      if(!value)
      {
        result = false;
        break;
      };
    }

    return result;
  }
}